import React from "react";
import "./Loader.css";

const Loader = (props) => {
    return (<span className="loader"></span>);
}

export default Loader;